var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"img-fluid e2e-image",style:(_vm.style),attrs:{"src":_vm.url,"alt":_vm.fragment.title,"title":_vm.fragment.title}})}
var staticRenderFns = []

export { render, staticRenderFns }